import React, { useState } from "react";
import { Grid, Collapse } from "@material-ui/core";
import {
  ButtonIcon,
  ICONS,
  SecondaryButton,
  PrimaryButton,
  ButtonSizeOptions
} from "@loanbossinc/component-library";

import { AssumptionsFormContent } from "..";
import "./styles.css";

const AssumptionsCard = ({ preferredConstraintsList, handleSubmit, savedAssumptions, onReset, ...formikProps }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const overflow = !isCollapsed ? { overflow: "visible" } : { overflow: "hidden" };

  return (
    <div className="assumptions-card-wrapper">
      <Grid container direction="column" xs={12}>
        <Grid item xs={12}>
          <div className="assumptions-card-title-section-wrapper">
            <div className="assumptions-card-title-text">Assumptions</div>
            <ButtonIcon
              onClick={() => setIsCollapsed(!isCollapsed)}
              iconName={isCollapsed ? ICONS.UNFOLD_MORE : ICONS.UNFOLD_LESS}
            />
          </div>
        </Grid>
        <Collapse in={!isCollapsed} style={overflow}>
          <AssumptionsFormContent {...formikProps} preferredConstraintsList={preferredConstraintsList} savedAssumptions={savedAssumptions} />
          <Grid item>
            <div className="assumptions-card-buttons-section-wrapper">
              <SecondaryButton
                className="assumptions-card-buttons"
                label="Reset"
                size={ButtonSizeOptions.smFluid}
                onClick={onReset}
              />
              <PrimaryButton
                className="assumptions-card-buttons"
                label="Save"
                size={ButtonSizeOptions.smFluid}
                onClick={handleSubmit}
              />
            </div>
          </Grid>
        </Collapse>
      </Grid>
    </div>
  );
};

export default AssumptionsCard;
